<template>
  <v-container id="home-container" fluid class="px-0 py-0">
    <v-main class="px-0 py-0">
      <!-- landing page with banner image -->
      <landing />

      <!-- conditionally rendered responsive nav bar -->
      <transition name="dropdownnav">
        <navigation v-if="getNavBarState"/>
      </transition>

      <!-- services highlights with links to '/services' page -->
      <services-highlight />

      <!-- about page highlights with link to '/about' page -->
      <about-highlight />

      <business-areas-highlight />

      <!-- projects page highlights with link to '/projects' page -->
      <projects-highlight />

      <!-- contact page highlights with link to '/contact' page -->
      <contact-highlight />
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'Home',

  watch: {
    getNavBarState () {
      // alert(this.getNavBarState)
    }
  }
}
</script>
